<template>
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex xs12 style="margin-top: 20px">
        <p v-if="$vuetify.breakpoint.xs" :class="$vuetify.breakpoint.smAndDown ? 'h2' : 'h1'">Hospedagem</p>

        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'" v-html="$store.state.hospedagem"></p>
      </v-flex>

      <Gracillis></Gracillis>

      <v-flex xs12 class="text-center" style="margin-top: 20px; padding: 0px">
        <p :class="$vuetify.breakpoint.smAndDown ? 'p16' : 'p20'">
          <a href="#reservas" @click.prevent="funcReservas">Reservas</a>
        </p>
      </v-flex>

      <v-flex xs12 :style="`height: ${$vuetify.breakpoint.xs ? '200px' : '100px'};`">&nbsp;</v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Gracillis from "./Gracillis.vue";

export default {
  components: {
    Gracillis
  },
  props: {
    contato: { default: false },
    reservas: { default: false }
  },
  data() {
    return {};
  },
  methods: {
    funcContato() {
      this.$emit("update:contato", true);
    },
    funcReservas() {
      this.$emit("update:reservas", true);
    }
  },
  computed: {
    urlPrivado() {
      return process.env.VUE_APP_URL_PRIVADO;
    }
  }
};
</script>
